import React, { useEffect, useState } from 'react';
import api from '../services/api';
import './Footer.css'; 

// Importa as imagens homologadas (Ajuste os caminhos conforme o projeto)
import logoBranca from '../assets/images/footer_logo.png'; // A logo do empreendimento
import iconePassaros from '../assets/images/icon-jb18.png'; // Os pássaros azuis da imagem 4
import bgGradiente from '../assets/images/bg-jb03.png'; // O gradiente elegante da imagem 5

const Footer = () => {
  const [settings, setSettings] = useState({
    social_instagram: '',
    social_facebook: '',
    social_youtube: '',
    whatsapp_number: '',
    company_address: '' 
  });
  
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    // Busca os dados do CMS
    api.get('/settings')
      .then(res => setSettings(res.data))
      .catch(err => console.error("Erro ao carregar footer:", err));

    // Lógica para mostrar/esconder o botão de Voltar ao Topo
    const checkScrollTop = () => {
      if (!showScroll && window.pageYOffset > 400) {
        setShowScroll(true);
      } else if (showScroll && window.pageYOffset <= 400) {
        setShowScroll(false);
      }
    };

    window.addEventListener('scroll', checkScrollTop);
    return () => window.removeEventListener('scroll', checkScrollTop);
  }, [showScroll]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const getWhatsappLink = () => {
    if (!settings.whatsapp_number) return '#';
    const cleanNumber = settings.whatsapp_number.replace(/\D/g, ''); 
    return `https://wa.me/${cleanNumber}`;
  };

  return (
    <>
      <footer className="footer-moderna mt-auto" style={{ backgroundImage: `url(${bgGradiente})` }}>
        
        {/* Camada de escurecimento sobre o gradiente para dar contraste */}
        <div className="footer-overlay"></div>

        {/* Botão Voltar ao Topo posicionado na divisa (Estilo Imagem 1) */}
        <div className="scroll-to-top-wrapper">
          <button 
            className={`btn-scroll-top shadow-lg ${showScroll ? 'visible' : ''}`} 
            onClick={scrollToTop}
            aria-label="Voltar ao topo"
          >
            <i className="bi bi-chevron-up"></i>
          </button>
        </div>

        <div className="container py-5 position-relative" style={{ zIndex: 2 }}>
          <div className="fonte-terciaria row gy-4 align-items-center">
            
            {/* Coluna Esquerda: Logo e Slogan */}
            <div className="col-lg-4 text-center text-lg-start">
              <img src={logoBranca} alt="Jurerê Blue" className="footer-logo mb-3" />
              <p className="footer-text-highlight mb-0 text-white-50">
                O endereço que reflete sua conquista.
              </p>
            </div>
            
            {/* Coluna Central: Detalhe Visual e Endereço */}
            <div className="col-lg-4 text-center">
              <img src={iconePassaros} alt="Detalhe Pássaros" className="footer-icon-birds mb-3 opacity-75" />
              <p className="footer-address mb-0 text-white fw-light">
                {settings.company_address || 'Alameda César Nascimento, 700. Jurerê Internacional, Florianópolis - SC.'}
              </p>
            </div>
            
            {/* Coluna Direita: Redes Sociais e Copyright */}
            <div className="col-lg-4 text-center text-lg-end">
              <div className="d-flex justify-content-center justify-content-lg-end gap-3 mb-3">
                {settings.social_instagram && (
                  <a href={settings.social_instagram} target="_blank" rel="noopener noreferrer" className="social-icon">
                    <div className="icon-circle"><i className="bi bi-instagram"></i></div>
                  </a>
                )}
                {settings.social_facebook && (
                  <a href={settings.social_facebook} target="_blank" rel="noopener noreferrer" className="social-icon">
                    <div className="icon-circle"><i className="bi bi-facebook"></i></div>
                  </a>
                )}
                {settings.social_youtube && (
                  <a href={settings.social_youtube} target="_blank" rel="noopener noreferrer" className="social-icon">
                    <div className="icon-circle"><i className="bi bi-youtube"></i></div>
                  </a>
                )}
              </div>
              <p className="small mb-0 footer-copyright text-white-50">
                &copy; {new Date().getFullYear()} Jurerê Blue.<br className="d-block d-md-none" /> Todos os direitos reservados.
              </p>
            </div>

          </div>
        </div>
      </footer>

      {/* Botão Flutuante do WhatsApp */}
      {settings.whatsapp_number && (
        <a href={getWhatsappLink()} target="_blank" rel="noopener noreferrer" className="whatsapp-float" aria-label="Fale conosco">
          <i className="bi bi-whatsapp"></i>
        </a>
      )}
    </>
  );
};

export default Footer;